export class Notificacion {
  id: string;
  idnotificacion: number;
  titulo: string;
  notificacion: string;
  estado: Boolean;
  fecha: Date;
  modulo: string;

  constructor(
    titulo: string,
    notificacion: string,
    modulo: string
  ) {
    this.titulo = titulo;
    this.notificacion = notificacion;
    this.modulo = modulo;
  }
}
